import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { graphql, gql, compose } from 'react-apollo'
import { withRouter, Redirect } from 'react-router-dom'
import { client } from '../index'

import { Loader, Form, TextInput, BirthdayInput } from './UI'

import { validateRequired } from '../libs/validation'
import { NotificationManager } from 'react-notifications'

import { translate } from 'react-i18next'

import withLoggedInUser from './withLoggedInUser'

import config from '../config.js'

class CreateUser extends Component {
  static propTypes = {
    createUser: PropTypes.func.isRequired,
  }

  state = {
    saving: false
  }

  handleChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  componentWillMount() {
    if (this.props.location.state) {
      if (this.props.location.state.email) {
        this.setState({email: this.props.location.state.email})
      }
      if (this.props.location.state.picture) {
        this.setState({picture: this.props.location.state.picture})
      }
      if (this.props.location.state.returnTo) {
        this.setState({returnTo: this.props.location.state.returnTo})        
      }
    }    
  }

  getFullUser = () => {
    client.query({
      query: userById,
      variables: {
        id: this.props.data.loggedInUser.id
      }
    })
    .then(result => {
        return result.data.User
    })
  }

  refreshUser = (userId) => {
    this.props.refreshUser(userId)
  }


  handleSubmit = values => {
    this.setState({
      saving: true
    })

    const userId = window.localStorage.getItem('user_id')
    const accessToken = window.localStorage.getItem('accessToken')

    fetch(config.authApiUrl + `users/${userId}`, {
      method: 'PATCH',
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${accessToken}`
      },
      body: JSON.stringify({ user_metadata: { name: values.phone } })
    })
      .then(() =>
        this.props.createUser({
          variables: {
            auth0Id: userId,
            email: values.email,
            birthDate: values.birthDate,
            firstName: values.firstName,
            lastName: values.lastName,
            phone: values.phone
          }
        })
      )
      .then(result => {
        this.setState({
          saving: false
        })
        this.refreshUser(result.data.createUser.id)
        this.props.history.push('/')
      })
      .catch(e => {
        this.setState({
          saving: false
        })
        NotificationManager.error(e.message, 'Error', 5000)
      })
  }

  render() {
    const { t } = this.props

    if (!this.props.loggedInUserChecked) {
      return <Loader />
    }

    let email = this.state.email
    let picture = this.state.picture
    let returnTo = this.state.returnTo

    // redirect if user is logged in or did not finish Auth0 Lock dialog
    if (this.props.loggedInUser || window.localStorage.getItem('auth0IdToken') === null) {
        // If there is no user image - try to use the profile one provided from auth0
        if (this.props.loggedInUser && this.props.loggedInUser.userProfile && !this.props.loggedInUser.userProfile.imageAvatar && picture) {
          window.localStorage.setItem('userImage', picture)
        } else {
          window.localStorage.removeItem('userImage')
        }

        if (returnTo) {
          this.props.history.push({
            pathname: returnTo,
            state: {
              afterLogin: true
            }
          })    
        } else {
          this.props.history.push({
            pathname: '/',
            state: {
              afterLogin: true
            }
          })    
        }
        return <div/>
    }
    else {
      const { saving } = this.state

      return (
        <div className="container">
          <div className="signup col-md-offset-4 col-md-4">
            <h1>{t('signup_title')}</h1>
            <Form
              onSubmit={this.handleSubmit}
              submitBtnClassname="btn btn-lg btn-primary btn-danger"
              submitBtnName={t('signup')}
              submittingToServer={saving}
            >
            <div className="row">
              <div className="form-group clearfix">
                <div className="col-md-9">
                <TextInput 
                  id="email" 
                  maxChars={50} 
                  validationFuncs={[validateRequired]} 
                  label={t('email')} 
                  initialValue={email} 
                  extraClass="form-input"
                />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group clearfix">
                <div className="col-md-9">
                <TextInput 
                  id="firstName" 
                  maxChars={50} 
                  validationFuncs={[validateRequired]} 
                  label={t('first_name')} 
                  extraClass="form-input"
                />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group clearfix">
                <div className="col-md-9">
                <TextInput 
                  id="lastName" 
                  maxChars={50} 
                  validationFuncs={[validateRequired]} 
                  label={t('last_name')} 
                  extraClass="form-input"
                />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group clearfix">
                <div className="col-md-9">
                <TextInput 
                  id="phone" 
                  maxChars={50} 
                  validationFuncs={[validateRequired]} 
                  label={t('phone')} 
                  extraClass="form-input"
                />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group clearfix">
                <div className="col-md-9">
                <BirthdayInput 
                  id="birthDate" 
                  label={t('birthday')} 
                  extraClass="form-input"
                />
                </div>
              </div>
            </div>
            </Form>
          </div>
        </div>
      )
    }
  }
}

const createUser = gql`
  mutation(
    $auth0Id: String!
    $email: String!
    $birthDate: DateTime!
    $lastName: String!
    $firstName: String!
    $phone: String!
  ) {
    createUser(
      auth0UserId: $auth0Id
      userProfile: { email: $email, birthDate: $birthDate, lastName: $lastName, firstName: $firstName, phone: $phone }
    ) {
      id
    }
  }
`
/*
const userQuery = gql`
  query userQuery {
    user {
      id
      userProfile {
        id
      }
    }
  }
`
*/

const userById = gql`
  query userById($id: bpchar!) {
    user(where: {id: {_eq: $id}}) {
      id
      userProfile {
        id
        imageAvatar {
          id
          url
          s3Url
        }
      }
    }
  }
  `

const userQuery = gql`
  query userQuery($accessToken: bpchar!) {
    loggedInUser(where: {token: {_eq: $accessToken}}){
      id
    }
  }
`

const enhance = compose(
  translate('main'),
  graphql(createUser, {
    name: 'createUser'
  }),
  withRouter,
  withLoggedInUser
)
export default enhance(CreateUser)




// WEBPACK FOOTER //
// src/components/CreateUser.jsx